"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAssociations = exports.ObjectAssociations = exports.Associations = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var associations_1 = require("../../bff/lib/associations");
var associations_2 = require("../../providers/associations");
function Associations(_a) {
    var associations = _a.associations, _b = _a.includeLabel, includeLabel = _b === void 0 ? false : _b;
    return (react_1.default.createElement(StyledAssociations, null, associations.map(function (association) { return (react_1.default.createElement(core_ui_1.TextLink, { key: association.dataUrl, variant: "secondary", onClick: function () { return window.open(association.viewUrl); }, style: { display: 'block' } }, (0, associations_1.getAssociationDisplayName)(association, includeLabel, 50))); })));
}
exports.Associations = Associations;
function ObjectAssociations() {
    var associations = (0, associations_2.useAssociationsContext)();
    return react_1.default.createElement(Associations, { associations: associations, includeLabel: true });
}
exports.ObjectAssociations = ObjectAssociations;
function UserAssociations() {
    var associations = (0, associations_2.useUserAssociationsContext)();
    return react_1.default.createElement(Associations, { associations: associations });
}
exports.UserAssociations = UserAssociations;
var StyledAssociations = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  a:not(:first-child) {\n    padding-top: 4px;\n  }\n"], ["\n  a:not(:first-child) {\n    padding-top: 4px;\n  }\n"])));
var templateObject_1;
